/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import { any, eqBy, toLower } from 'ramda';
import MarkdownDetail from './details/MarkdownDetail';
import IssueDetail from './details/IssueDetail';
import SeverityDetail from './details/SeverityDetail';
import WeaknessDetail from './details/WeaknessDetail';
import SourceDetail from './details/SourceDetail';
import CategoriesDetail from './details/CategoriesDetail';
import DescriptionDetail from './details/DescriptionDetail';
import AdvisoriesDetail from './details/AdvisoriesDetail';
import CVSSDetail from './details/CVSSDetail';
import RootCauseDetail from './details/RootCauseDetail';
import './NxVulnerabilityDetails.scss';
import { propTypes } from './types';
import { NxH2 } from '../SimpleComponents';
export { vulnerabilityDetailsPropType } from './types';
var MALICIOUS_CODE = 'malicious_code'; // eslint-disable-line @typescript-eslint/no-inferrable-types
var NxVulnerabilityDetails = function NxVulnerabilityDetails(_a) {
    var vulnerabilityDetails = _a.vulnerabilityDetails;
    var categories = vulnerabilityDetails.categories || [], hasMaliciousCodeCategory = any(eqBy(toLower, MALICIOUS_CODE), categories), maliciousCodeWarning = hasMaliciousCodeCategory ? 'Malicious Code' : null;
    return (React.createElement("div", { className: "nx-vulnerability-details" },
        React.createElement(NxH2, null, vulnerabilityDetails.identifier),
        React.createElement("div", { className: "nx-grid-row" },
            React.createElement("div", { className: "nx-grid-col" },
                React.createElement(IssueDetail, { identifier: vulnerabilityDetails.identifier, vulnerabilityLink: vulnerabilityDetails.vulnerabilityLink }),
                React.createElement(SeverityDetail, { mainSeverity: vulnerabilityDetails.mainSeverity, severityScores: vulnerabilityDetails.severityScores }),
                React.createElement(WeaknessDetail, { weakness: vulnerabilityDetails.weakness }),
                React.createElement(SourceDetail, { source: vulnerabilityDetails.source }),
                React.createElement(CategoriesDetail, { categories: vulnerabilityDetails.categories })),
            React.createElement("div", { className: "nx-grid-col" },
                React.createElement(DescriptionDetail, { source: vulnerabilityDetails.source, description: vulnerabilityDetails.description }),
                React.createElement(MarkdownDetail, { title: "Explanation", warning: maliciousCodeWarning, markdown: vulnerabilityDetails.explanationMarkdown, componentSpecificMarkdown: vulnerabilityDetails.componentExplanationMarkdown }),
                React.createElement(MarkdownDetail, { title: "Detection", markdown: vulnerabilityDetails.detectionMarkdown, componentSpecificMarkdown: vulnerabilityDetails.componentDetectionMarkdown }),
                React.createElement(MarkdownDetail, { title: "Recommendation", markdown: vulnerabilityDetails.recommendationMarkdown, componentSpecificMarkdown: vulnerabilityDetails.componentRecommendationMarkdown }),
                React.createElement(RootCauseDetail, { rootCauses: vulnerabilityDetails.rootCauses }),
                React.createElement(AdvisoriesDetail, { advisories: vulnerabilityDetails.advisories }),
                React.createElement(CVSSDetail, { severity: vulnerabilityDetails.mainSeverity })))));
};
NxVulnerabilityDetails.propTypes = propTypes;
export default NxVulnerabilityDetails;
//# sourceMappingURL=NxVulnerabilityDetails.js.map